import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntPivotGrid from './AntPivotGrid';

export default forwardRef(function (props, ref) {
    const grid = useRef();

    const reload = (opts) => {
        if (grid.current) {
            grid.current.forceReload(opts);
        }
    };

    const refresh = () => {
        if (grid.current) {
            grid.current.refresh();
        }
    };

    useImperativeHandle(ref, () => ({
        refresh: refresh,
        reload: reload
    }));

    let storageKey = props.storageKey
        ? props.storageKey
        : 'searching-pivot-grid-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

    return (
        <React.Fragment>
            <AntPivotGrid
                ref={grid}
                API={props.API}
                url={props.url}
                table={props.table}
                isSearching={true}
                chart={props.chart}
                showChart={props.showChart}
                searchConditions={props.searchConditions}
                searchFields={props.searchFields}
                entityName={props.entityName}
                entityDisplay={props.entityDisplay}
                storageKey={props.storageKey ? props.storageKey : storageKey}
                keyExpr={props.keyExpr}
                loadFunc={props.loadFunc}
                fields={props.fields}
                queryFields={props.queryFields}
                selectFields={props.selectFields}
                configFields={props.configFields}
                actionItems={props.actionItems}
                options={props.options}
                onFilteredByGroupChanged={props.onFilteredByGroupChanged}
                searchText={props.searchText}
                onSearchText={props.onSearchText}
                isAllowQuery={props.isAllowQuery}
                showActionBar={props.showActionBar}
                showRefresh={props.showRefresh ? props.showRefresh : true}
                showDownload={props.showDownload}
                showSearchBar={props.showSearchBar}
                autoFocusSearchBar={props.autoFocusSearchBar}
                showFieldChooser={props.showFieldChooser}
                locationRefresh={props.locationRefresh}
                locationDownload={props.locationDownload}
                hideHeaderMargin={props.hideHeaderMargin}
                onLoaded={props.onLoaded}
                onCellPrepared={props.onCellPrepared}
                showColumnTotals={props.showColumnTotals}
                showColumnGrandTotals={props.showColumnGrandTotals}
                showRowTotals={props.showRowTotals}
                showRowGrandTotals={props.showRowGrandTotals}
                isMonthlyReport={props.isMonthlyReport}
                isCurrency={props.isCurrency}
                visible={props.visible}
                searchCategories1={props.searchCategories1}
                searchCategories2={props.searchCategories2}
                searchCategories3={props.searchCategories3}
                searchCategories4={props.searchCategories4}
                searchCategories5={props.searchCategories5}
                searchCategories6={props.searchCategories6}
                searchCategories7={props.searchCategories7}
                searchCategories8={props.searchCategories8}
                searchCategories9={props.searchCategories9}
                searchCategories10={props.searchCategories10}
            />
        </React.Fragment>
    );
});
